<div class="ads-container">
    <form class="form-wrapper mt-2" [formGroup]="imagesForm" (ngSubmit)="onSubmit()">
        @if (appFacadeService.versionToggleService.isAdvanceVersion()) {
        <ng-container [ngTemplateOutlet]="adBanners" [ngTemplateOutletContext]="{ imagesForm: imagesForm }"></ng-container>
        }
        <por-base-button (onclick)="onSubmit()" class="theme-button apply-btn" [disabled]="imagesForm.invalid" [featureName]="'admin-ad-save-button-data'">
            {{ 'Save' | translate }}
        </por-base-button>
    </form>
</div>
<ng-template #adBanners let-imagesForm="imagesForm">
    <p>{{ 'adsectionInstruction1' | translate }}</p>
    <p>
        <strong>{{ 'AdsSizeInstructions1' | translate }}</strong>
    </p>
    <p>{{ 'AdsSizeInstructions2' | translate }}</p>
    <div class="ads-wrapper-two" [formGroup]="imagesForm">
        <div class="right-section">
            <div class="droppers-section">
                <div formArrayName="banners">
                    <div class="image-cards-row">
                        @for (bannerGroup of bannersArray.controls; track bannerGroup; let i = $index) {
                        <mat-card class="image-card" appearance="outlined" [formGroupName]="i">
                            <mat-card-header>
                                <h2>{{ banners[i].imageTitle | translate }}</h2>
                            </mat-card-header>
                            <mat-card-content>
                                <por-ad-drag-drop
                                    (uploadSuccess)="handleFile($event, fileType.Banner, banners[i].type)"
                                    [uiTitle]="banners[i].title | translate"
                                    [allowDelete]="true"
                                    [previewDimension]="{ width: '250px', height: '112px' }"
                                    (removeFile)="setBannersValues(banners[i].type, '')"
                                    [currentImage]="bannersArray.at(i).value[banners[i].type]"></por-ad-drag-drop>
                                <div class="form-group-container">
                                    <div class="form-group">
                                        @if (!isFeatureForceHidden('AiGenerateImages')) {
                                        <por-base-button class="ai-img-btn" porAdDragExtraActions (onclick)="openAiDialog(i)" [featureName]="'ai-generate-image-' + i">
                                            {{ 'aiImageGenerateButton' | translate }}
                                        </por-base-button>
                                        }
                                        <apx-form-field
                                            [label]="banners[i].urlTitle | translate"
                                            [classList]="'flex-row'"
                                            [error]="bannersArray.at(i).get(banners[i].type + 'ExternalUrl')?.invalid && (bannersArray.at(i).get(banners[i].type + 'ExternalUrl')?.dirty || bannersArray.at(i).get(banners[i].type + 'ExternalUrl')?.touched) ?
                                            bannersArray.at(i).get(banners[i].type + 'ExternalUrl')?.errors?.['invalidUrl'] ? ('InvalidUrl' | translate) :
                                            ''
                                            : '' ">
                                            <input apxInput type="url" [placeholder]="'EnterUrl' | translate" [formControlName]="banners[i].type + 'ExternalUrl'" />
                                        </apx-form-field>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
